import { NationalCommitteesCatalogRedirect } from "./_NationalCommitteesRedirect";

export default function AllCommitteesPage() {
  return <NationalCommitteesCatalogRedirect status="all" />;
}
